import axios from 'axios'
import router from '@/router/index'
import {Notify} from 'vant';
import {baseApi, getToken, removeToken} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
    baseURL: baseApi(), // api 的 base_url
    timeout: 1200000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        if (getToken()) {
            config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        }
        config.headers['Content-Type'] = 'multipart/form-data'
        return config
    },
    error => {
        // Do something with request error
        // eslint-disable-next-line no-console
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const code = response.status
        if (code < 200 || code > 300) {
            Notify({type: 'warning', message: response.message, duration: 5000})
            return Promise.reject('error')
        } else {
            return response.data
        }
    },
    error => {
        let code = 0
        try {
            code = error.response.data.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                Notify({type: 'danger', message: '网络请求超时', duration: 5000})
                return Promise.reject(error)
            }
        }
        if (code) {
            if (code === 401) {
                //未登录
                removeToken()
                router.push({path: '/login', query: {path: router.app._route.path}})
            } else if (code === 403) {
                router.push({path: '/401'})
            } else {
                const errorMsg = error.response.data.message
                if (errorMsg !== undefined) {
                    Notify({type: 'danger', message: errorMsg, duration: 5000});
                }
            }
        } else {
            Notify({type: 'danger', message: '接口请求失败', duration: 5000});
        }
        return Promise.reject(error)
    }
)
export default service
